import { FormattedMessage, useIntl } from "react-intl";
import SearchOptionItem from "./SearchOptionItem";

type Props = {
  options: string[];
  onChange: $TSFixMeFunction;
};

export function SearchOptions({ options, onChange }: Props) {
  const intl = useIntl();

  const handleOptionChange = (optionName: $TSFixMe, checked: $TSFixMe) => {
    if (checked) {
      onChange([...options, optionName]);
    }
    if (!checked) {
      onChange(options.filter((item) => item !== optionName));
    }
  };

  return (
    <ul className="list-inline">
      <li className="list-inline-item option-label">
        <span className="additional-info">
          <FormattedMessage id="search.options" />
        </span>
      </li>
      <SearchOptionItem
        label={intl.formatMessage({ id: "search.options.show_specifications" })}
        option="specifications"
        onChange={handleOptionChange}
        checked={options.indexOf("specifications") >= 0}
      />
      <SearchOptionItem
        label={intl.formatMessage({ id: "search.options.show_assigned_nodes" })}
        option="nodes"
        onChange={handleOptionChange}
        checked={options.indexOf("nodes") >= 0}
      />
    </ul>
  );
}

export default SearchOptions;
